import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import GetAny from 'src/utils/GetAny'
import ArchiveItem from 'src/components/Archive/ArchiveItem'
import Wave from 'src/utils/Wave'

const ThreeColumnCards = ({ blok }) => {

    // If no items are selected then grab the lastest 3 of the selected post type
    const posts = blok.posts.length < 1 ? GetAny(blok.posts, blok.post_type, 3) : GetAny(blok.posts)

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                <Wave size="small" className={`fill-lightgrey`} flip/>
                <div className="bg-lightgrey">
                    <div className="relative max-w-7xl mx-auto px-6 lg:py-24 py-12 2xl:max-w-screen-2xl">
                        <div className="flex lg:flex-row flex-col lg:justify-between lg:items-end gap-y-4">
                            <div>
                                <Heading size="h3" className="">{blok.title}</Heading>
                                <div className="prose lg:text-base text-sm max-w-3xl">
                                    <RichText>{blok.description}</RichText>
                                </div>
                            </div>
                            {blok.button_text &&
                                <div>
                                    <Button to={blok.button_target.cached_url} className="bg-red hover:bg-darkred">{blok.button_text}</Button>
                                </div>
                            }
                        </div>
                        <div className="lg:pt-14 pt-10 grid gap-8 md:grid-cols-3">
                            {posts.map((item) => (
                                <ArchiveItem {...item} key={item.uuid}/>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </SbEditable>
    )
}

export default ThreeColumnCards